export default "__VITE_ASSET__84dcac74__"